import React, { useEffect, useState } from "react";
import { Col, Input, Row, Select, Form, DatePicker } from "antd";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createProject,
  setProjectDetailsIsEdit,
  updateProject,
} from "../redux/actions";
import SpinnerComponent from "../../../components/spinner";
import { isValidNumber } from "../../../globalUtils/axiosConfig";
import moment from "moment";
import AttachmentsSection from "./attachmentsSection";

const ProjectDetailsSection = ({ isProjectUpdate, canUpdate }) => {
  const [documents, setDocuments] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [utils, setUtils] = useState({});
  const [currentProject, setCurrentProject] = useState({});

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Option } = Select;

  const {
    createProjectLoading,
    currentProjectObj,
    projectDetailsIsEdit,
    utilsData,
  } = useSelector((state) => state.projectsSetupReducer);

  const { allProjectStatuses } = useSelector(
    (state) => state.projectStatusReducer
  );

  useEffect(() => {
    // dispatch(fetchUserDetailsUtils());
  }, []);

  useEffect(() => {
    setCurrentProject(currentProjectObj);

    const { end_date, start_date, document_urls } = currentProjectObj;

    form.setFieldsValue({
      ...currentProjectObj,
      end_date: moment(end_date),
      start_date: moment(start_date),
    });

    if (document_urls && document_urls?.length >= 0) {
      let updatedImages = document_urls.map((img) => {
        const { id, url } = img;
        let name = url.split("/")[url.split("/").length - 1].split("?")[0];
        return { key: id, image: url, isLocal: false, name };
      });

      setDocuments(updatedImages);
    }
    setUtils(utilsData);
  }, [currentProjectObj, utilsData]);

  useEffect(() => {
    setLoading(createProjectLoading);
    // if (createProjectLoading) {
    //   setIsUserImgSelected(false);
    // }
  }, [createProjectLoading]);

  useEffect(() => {
    setIsEdit(projectDetailsIsEdit);
  }, [projectDetailsIsEdit]);

  const onChange = (value) => {
    // console.log(`selected ${value}`);
  };

  const onFinish = (values) => {
    const { ...res } = values;

    isProjectUpdate
      ? dispatch(
          updateProject({
            ...res,
            ...(documents && { documents }),
            id: currentProjectObj.id,
          })
        )
      : dispatch(
          createProject({
            ...res,
            documents,
          })
        );
  };
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const handleSave = () => {
    form.submit();
  };

  // const capitalizeFirstLetter = (str) =>
  //   str && str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <>
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span">Project Details</span>
              </div>
            </Col>
            <Col>
              {isEdit ? (
                loading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon width={16} height={16} onClick={handleSave} />
                )
              ) : (
                canUpdate && (
                  <EditIcon
                    width={16}
                    fill="#e21c21"
                    height={16}
                    onClick={() => dispatch(setProjectDetailsIsEdit(true))}
                  />
                )
              )}
            </Col>
          </Row>
        </Col>
        <Col
          span={24}
          className={`user-details-section project-details-section ${
            !isEdit && "is-edit"
          }`}
        >
          <Row justify="center">
            <Col md={24} lg={23} xl={20} xxl={16}>
              <Form
                {...formItemLayout}
                form={form}
                name="user-details"
                onFinish={onFinish}
                initialValues={currentProject}
                scrollToFirstError
                labelWrap={true}
                layout="horizontal"
                className="user-detail-form"
                requiredMark={false}
              >
                <Row gutter={[20, 10]}>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="project_number"
                      label="PROJECT NUMBER"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Project Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                      name="proposal_number"
                      label="Proposal Number"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Proposal Number"
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        { pattern: isValidNumber, message: "Invalid" },
                      ]}
                      name="document_numbering_abbreviation"
                      label="Document Numbering Abbreviation"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Document Numbering Abbreviation"
                      />
                    </Form.Item>
                  </Col> */}
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="client"
                      label="Client"
                    >
                      <Input
                        readOnly={loading}
                        disabled={
                          !isEdit ||
                          // isProjectUpdate ||
                          !canUpdate
                        }
                        placeholder="Client"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="location"
                      label="Location"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Location"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      name="contract_number"
                      label="Contract Number"
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit} // || isProjectUpdate
                        placeholder="Contract Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="project_type"
                      label="Type of Project"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Type of Project"
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="start_date"
                      label="Start Date"
                    >
                      <DatePicker
                        style={{
                          width: "100%",
                        }}
                        format="D-MM-YYYY"
                        allowClear={false}
                        suffixIcon={null}
                        placeholder="Select Start Date"
                        disabled={!isEdit || !canUpdate || loading}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      name="end_date"
                      label="End Date"
                      dependencies={["start_date"]}
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              moment(
                                getFieldValue("start_date")
                              ).isSameOrBefore(value)
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("End date should be after start date!")
                            );
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        suffixIcon={null}
                        style={{
                          width: "100%",
                        }}
                        format="D-MM-YYYY"
                        allowClear={false}
                        placeholder="Select End Date"
                        disabled={!isEdit || !canUpdate || loading}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="project_status_id"
                      label="Project Status"
                    >
                      <Select
                        style={{
                          width: "100%",
                        }}
                        disabled={!isEdit || !canUpdate}
                        readOnly={true}
                        className="department-select"
                        dropdownClassName="select-dropdown-custom"
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        showSearch
                        placeholder="Select Project Status"
                        optionFilterProp="children"
                        onChange={onChange}
                        // onSearch={onSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {allProjectStatuses.map(({ id, status_name }) => {
                          return (
                            <Option key={id} value={id}>
                              {status_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="project_scope"
                      label="Project Scope"
                    >
                      <TextArea
                        className="scope"
                        rows={7}
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Insert Project Scope"
                      />
                    </Form.Item>
                    <AttachmentsSection
                      isEdit={isEdit}
                      loading={loading}
                      documents={documents}
                      setDocuments={setDocuments}
                      currentProject={currentProject}
                    />
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="empty-div"></div>
    </>
  );
};

export default ProjectDetailsSection;
